import { AnyAction } from 'redux';
import { TaxSelectedType } from 'Types/common';
import { initialState } from './initialState';

import * as types from './types';

export type TaxStateType = {
  taxSelected: TaxSelectedType;
};

const reducer = (
  state: TaxStateType = initialState,
  action: AnyAction = { type: '' }
): TaxStateType => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_TAX_SELECTED:
      return {
        ...state,
        taxSelected: { ...state.taxSelected, ...payload.taxSelected },
      };
    default:
      return state;
  }
};

export default reducer;
